import config from 'config';

const tldNavLinkMetadata = config.get('public.tldNavLinkMetadata') || [];

/**
 * @description An array of locale codes supported by the brand as defined in the config.
 * @type {Array<string>}
 */
const brandSupportedLocales = tldNavLinkMetadata.map((country) => {
  return country.code;
});

export default brandSupportedLocales;
